import React, { Component, Fragment } from 'react'
import classnames from 'classnames'
import * as api from '../../../api'
import UserBar from '../../common/user-bar/user-bar'

const scope = 'QuestionsPage'
class QuestionsPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
    }
    this.logOut = this.logOut.bind(this)
  }

  componentDidMount() {
    this.getUserData()
  }

  getUserData() {
    api
      .getUserData()
      .then(user => {
        this.setState({
          loading: false,
          user,
        })
      })
      .catch(() => {
        this.setState({ loading: false })
      })
  }

  logOut() {
    api.logOut().then(this.setState({ user: null }))
  }

  render() {
    const { className, config } = this.props
    const { loading, user } = this.state
    const questions = [
      {
        question: (
          <Fragment>
            What does <b>we're doing it live</b> mean
          </Fragment>
        ),
        answer: (
          <Fragment>
            When I'm working on this site, I switch it over from production to development mode, allowing the site to
            automatically re-render when any changes are made. During this time, I'm probably streaming the development
            of this site on Twitch. I'm always up for discussion, so you're welcome to watch and ask questions on{' '}
            <a
              target='_blank'
              rel='noopener noreferrer'
              href='https://www.twitch.tv/silencedraconem'
              title='Silence on Twitch'
            >
              my Twitch channel
            </a>
            .
          </Fragment>
        ),
      },
      {
        question: <Fragment>Why log in?</Fragment>,
        answer: <Fragment>Logging in adds you to the list of streamers, and will allow you to be featured.</Fragment>,
      },
      {
        question: (
          <Fragment>
            What does <b>{config.siteName} Partner Streamer</b> indicate?
          </Fragment>
        ),
        answer: (
          <Fragment>
            {config.siteName} Partner Streamer indicates that this streamer has partnered with {config.siteName} or its{' '}
            <span className='info' title='Yeah, I am developing one of those, too.'>
              chatbot
            </span>{' '}
            for beta testing and/or has provided some other sort of super-useful assistance.
          </Fragment>
        ),
      },
      {
        question: <Fragment>Why was this site created?</Fragment>,
        answer: (
          <Fragment>
            Stream Watch was created for a few reasons. I haven't done a Node + Express + MySQL backend before (I'm a
            frontend guy, mostly), and wanted to try my hand at it. The major reason, however, is that other focused
            sites that I've seen advertised are devoid of what I consider to be required feature sets, including
            much-needed accessibility and usability for those who are blind / colorblind / etc.
          </Fragment>
        ),
      },
      {
        question: <Fragment>Easter eggs?</Fragment>,
        answer: <Fragment>I like them. Shhhhh.</Fragment>,
      },
    ]

    const Question = ({ question, answer }) => (
      <div className={`${scope}-FAQ`}>
        <h3 className={`${scope}-Question`}>{question}</h3>
        <h4 className={`${scope}-Answer`}>{answer}</h4>
      </div>
    )

    return (
      <div className={classnames(scope, className)}>
        <div className={classnames(`${scope}-Header`)}>
          {!loading ? <UserBar user={user} onLogOut={this.logOut} /> : null}
          {questions.map((q, i) => (
            <Question key={`Question_${i}`} {...q} />
          ))}
        </div>
      </div>
    )
  }
}

export default QuestionsPage



// WEBPACK FOOTER //
// ./src/components/views/questions-page/questions-page.jsx